export default __webpack_public_path__ + "static/email-img-1de2629c8309bc05ea499e34fe77b78a.png";